import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';

import { Box } from '../../../Box';
import { Text } from '../../../Text';
import { SharedCheckboxRadioGroupProps } from './types';

const { radioCheckbox } = tokens;

/**
 * Error message for radio checkbox groups
 */
export const CheckboxRadioGroupError = ({
  errorText,
}: Pick<SharedCheckboxRadioGroupProps, 'errorText'>) =>
  !!errorText && typeof errorText === 'string' ? (
    <Box testID="checkbox-radio-group-error-message">
      <Text
        tag="span"
        typography={radioCheckbox.typography.errorMessage.default}
        color={radioCheckbox.color.content.errorMessage.default}
      >
        {errorText}
      </Text>
    </Box>
  ) : null;
